import { ShieldAlert } from 'lucide-react'

export function NotAuthorizedState() {
  return (
    <div className="flex flex-col items-center justify-center rounded-card border border-dashed border-line bg-panel p-10 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-danger-soft text-danger">
        <ShieldAlert className="h-7 w-7" />
      </div>
      <h2 className="mt-5 font-serif text-2xl font-normal text-ink">No autorizado</h2>
      <p className="mt-2 max-w-md text-sm text-ink-muted">
        Solo el propietario de la organización puede acceder a la gestión de usuarios. Si crees
        que esto es un error, contacta al propietario.
      </p>
    </div>
  )
}
